import { render, staticRenderFns } from "./FutureSelfLetter.vue?vue&type=template&id=570f6a8b&"
import script from "./FutureSelfLetter.vue?vue&type=script&lang=js&"
export * from "./FutureSelfLetter.vue?vue&type=script&lang=js&"
import style0 from "./FutureSelfLetter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports